import "./index.sass";

interface TVProps {
  children: React.ReactNode;
  extra?: React.ReactNode;
}

const TV = ({ children, extra }: TVProps) => {
  return (
    <div className="panel-right">
      {children}
      <div>{extra}</div>
    </div>
  );
};

export default TV;
